import { accessTokenListener } from './access-token';
import { toggleMobileMenuListener, dropdownToggleListener } from './header';
import {
  updateWebcatLinks,
  watchFormFields,
  watchHomeLoginButton,
  watchUrlParameters,
} from './login';

document.addEventListener('DOMContentLoaded', () => {
  accessTokenListener();
  watchFormFields();
  watchUrlParameters();
  watchHomeLoginButton();
  toggleMobileMenuListener();
  updateWebcatLinks();
  dropdownToggleListener();

  window.addEventListener('resize', () => {
    toggleMobileMenuListener();
  });
});
